export default __webpack_public_path__ + "static/media/screen3.04d68a8b.png";